import { Fragment, ReactElement } from 'react';

import { FieldDatePicker } from './FieldDatePicker';
import { FieldText } from './FieldText';
import { FieldPattern } from './FieldPattern';

interface FieldsComponent {
  (): ReactElement;
  DatePicker: typeof FieldDatePicker;
  Text: typeof FieldText;
  Pattern: typeof FieldPattern;
}

export const Fields: FieldsComponent = () => <Fragment />;

Fields.DatePicker = FieldDatePicker;
Fields.Text = FieldText;
Fields.Pattern = FieldPattern;
